import { render, staticRenderFns } from "./videoGallery.vue?vue&type=template&id=33b9cb11&scoped=true"
import script from "./videoGallery.vue?vue&type=script&lang=js"
export * from "./videoGallery.vue?vue&type=script&lang=js"
import style0 from "./videoGallery.vue?vue&type=style&index=0&id=33b9cb11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b9cb11",
  null
  
)

export default component.exports